import MessageChannel from './message_channel'
export default class MessageChannelQWebChannel extends MessageChannel {
  connect() {
    return new Promise((resolve, reject) => {
      /* tslint:disable */
      if (typeof window.QWebChannel === 'undefined' || typeof window.qt === 'undefined') {
        reject()
      }
      else {
        new window.QWebChannel(window.qt.webChannelTransport, (channel) => {
          this.channel = channel.objects._promobot_internal
          this.channel.message.connect((message) => {
            console.debug('accepted message', message)
            this.handle(message)
          })
          resolve()
        })
      }
    })
  }
  send(message) {
    /* tslint:disable */
    console.debug('send message', message)
    this.channel.sendMessage(message)
  }
}
